import JobEditModal from "./job-edit-modal";

export default JobEditModal;